import { Droplet, Search, Disc3, BatteryCharging, Gauge, Snowflake, Cog, Zap } from "lucide-react";

export const SERVICE_META = {
  "oil-change": {
    icon: Droplet,
    image: "https://images.pexels.com/photos/13065693/pexels-photo-13065693.jpeg",
    features: ["Synthetic blend or full synthetic", "Premium / OEM filter", "Fluid check", "Fluid top-off", "Filter check", "Industrial-grade spill mats"],
  },
  "vehicle-inspection": {
    icon: Search,
    image: "https://images.pexels.com/photos/4489761/pexels-photo-4489761.jpeg",
    features: ["Fluid check", "Fluid top-off", "Filter check", "Tire pressure check", "Tire rotation", "Brake inspection", "Battery test", "Pre-purchase inspection"],
  },
  "brake-service": {
    icon: Disc3,
    image: "https://images.pexels.com/photos/34277923/pexels-photo-34277923.jpeg",
    features: ["Front &/or rear", "Pads & rotors", "Fluid flush", "Road test"],
  },
  "engine-tune-up": {
    icon: Gauge,
    image: "https://static.prod-images.emergentagent.com/jobs/545affd5-2387-4a3b-a855-b9929942af23/images/65ab2c42c6bc2d87630c494d8df87a6c11d6140e25ecc3456f858c0d401d822c.jpeg",
    features: ["NGK Laser Iridium plugs", "Prevents misfires", "4/6/8-cylinder", "Air filter add-ons"],
  },
  "battery-replacement": {
    icon: BatteryCharging,
    image: "https://images.pexels.com/photos/4374843/pexels-photo-4374843.jpeg",
    features: ["Premium battery", "Load tested", "Terminal clean", "Old core recycled"],
  },
  "ac-repair": {
    icon: Snowflake,
    image: "https://static.prod-images.emergentagent.com/jobs/545affd5-2387-4a3b-a855-b9929942af23/images/a3033dd28b1799410c7b1943d0e5cd6d04b04ed71da9933a4a1003d62edb98c2.jpeg",
    features: ["Refrigerant recharge", "Leak diagnosis", "Compressor check", "Cabin cooling test"],
  },
  "serpentine-belt": {
    icon: Cog,
    image: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Belt inspection", "OEM-grade belt", "Tensioner add-on", "Road test"],
  },
  "alternator-replacement": {
    icon: Zap,
    image: "https://images.unsplash.com/photo-1757547570448-04946db22218?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    features: ["Charging-system test", "Alternator swap", "Battery check", "Road test"],
  },
};

export const TIME_SLOTS = [
  "08:00 AM", "09:30 AM", "11:00 AM",
  "12:30 PM", "02:00 PM", "03:30 PM", "05:00 PM",
];
